import {createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import thunk from 'redux-thunk';
import rootSaga  from './sagas'
import rootReducer from './reducers'

const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware();

export type RootState = ReturnType<typeof rootReducer>

export const store = createStore(persistedReducer, composeEnhancers(
  applyMiddleware(sagaMiddleware, thunk)
));
export const persistor = persistStore(store)

sagaMiddleware.run(rootSaga);